<div class="mt-1">
  <div *ngIf="isCrossBoundryCreating" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-accordion>
    <p-accordionTab header="{{ 'Common.Form.Header' | translate }}"  [(selected)]="isSearchFormOpen" >
      <form [formGroup]="createForm">
        <div class="grid">
          <div class="col-12">
            <div class="p-fluid formgrid grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <span class="requiredStart">*</span><label>{{ 'CreateCrossBoundryDialog.CreateForm.CbType' | translate }}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                [options]="cbTypeOptions" [showClear]="true"  [(ngModel)]="cbType"
                formControlName="cbType">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <span class="requiredStart">*</span><label>{{ 'CreateCrossBoundryDialog.CreateForm.CreateCarType' | translate }}</label>
                <laas-car-type-selector formControlName="createCarType"
                  [facility]="laasSetting.facility">
                </laas-car-type-selector>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3" *ngIf="cbType != 3">
                <span class="requiredStart">*</span><label>{{ 'CreateCrossBoundryDialog.CreateForm.ShipForwarder' | translate }}</label>
                <p-dropdown formControlName="forwarder" formControlName="shipForwarder" [options]="forwarderOptions" [filter]="true"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </p-dropdown>

              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3" *ngIf="[3, 4, 5].includes(cbType)">
                <span class="requiredStart">*</span><label>{{ 'CreateCrossBoundryDialog.CreateForm.CustomsForwarder' | translate }}</label>
                <p-dropdown formControlName="forwarder" formControlName="customsForwarder" [options]="forwarderOptions" [filter]="true"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </p-dropdown>

              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <span class="requiredStart">*</span><label>{{ 'CreateCrossBoundryDialog.CreateForm.CbMainType' | translate }}</label>
                <br><br>
                <div class="block">
                  <p-radioButton
                    formControlName="cbMainType"
                    name="cbMainType"
                    value='CT'
                    label="集運"
                    [(ngModel)]="cbMainType"
                  ></p-radioButton>
                  <p-radioButton
                    formControlName="cbMainType"
                    name="cbMainType"
                    value='CB'
                    label="跨境"
                    class="ml-2"
                    [(ngModel)]="cbMainType"
                  ></p-radioButton>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3" *ngIf="cbMainType === 'CT'">
                <span class="requiredStart">*</span><label for="formCountry">{{ 'CreateCrossBoundryDialog.CreateForm.FromCountry' | translate}}</label>
                <p-dropdown
                  inputId="formCountry"
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="countryOptions"
                  [showClear]="true"
                  (onChange)="onCountryChange($event, 'from')"
                  appendTo="body"
                  formControlName="fromCountry">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3" *ngIf="cbMainType === 'CT'">
                <span class="requiredStart">*</span><label>{{ 'CreateCrossBoundryDialog.CreateForm.FromCity' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="fromCityOptions"
                  [showClear]="true"
                  appendTo="body"
                  (onChange)="onCountryChange($event, 'from')"
                  formControlName="fromCity">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3" *ngIf="cbMainType === 'CT'">
                <label>{{ 'CreateCrossBoundryDialog.CreateForm.FromArea' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="fromAreaOptions" [showClear]="true"
                  formControlName="fromArea">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3" *ngIf="cbMainType === 'CT'">
                <span class="requiredStart">*</span><label for="formCountry">{{ 'CreateCrossBoundryDialog.CreateForm.ToCountry' | translate}}</label>
                <p-dropdown
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="countryOptions"
                  [showClear]="true"
                  (onChange)="onCountryChange($event, 'to')"
                  appendTo="body"
                  formControlName="toCountry">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3" *ngIf="cbMainType === 'CT'">
                <span class="requiredStart">*</span><label>{{ 'CreateCrossBoundryDialog.CreateForm.ToCity' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="toCityOptions"
                  [showClear]="true"
                  appendTo="body"
                  (onChange)="onCountryChange($event,  'to')"
                  formControlName="toCity">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3"  *ngIf="cbMainType === 'CT'">
                <label>{{ 'CreateCrossBoundryDialog.CreateForm.ToArea' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="toAreaOptions" [showClear]="true"
                  formControlName="toArea">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label class="block mb-1">{{ 'CreateCrossBoundryDialog.CreateForm.MultipleAddressType' | translate }}</label>
                <br>
                <div class="block">
                  <p-radioButton
                    formControlName="multipleAddressType"
                    name="multipleAddressType"
                    value='Normal'
                    label="一般"
                  ></p-radioButton>
                  <p-radioButton
                    formControlName="multipleAddressType"
                    name="multipleAddressType"
                    value='Special'
                    label="特殊"
                    class="ml-2"
                  ></p-radioButton>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mt-2 text-center">
              <button pButton pRipple label="{{ 'TruckCostAllocation.Button.CreateCb' | translate }}"
              (click)="createBtnClick()"></button>
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-2"
              (click)="resetBtnClick($event)"></button>
            </div>
          </div>
          <strong class="p-invalid">
            {{ "CreateCrossBoundryDialog.Message.NotificationMsg" | translate }}
          </strong>
        </div>
      </form>
    </p-accordionTab>
  </p-accordion>
</div>

